import { BannerModel } from '@/logic/services';
import { FC } from 'react';
import { SliderExternalLinkInfo } from './slider-external-link-info';
import { SliderFilmInfo } from './slider-film-info';
import { SliderOfferInfo } from './slider-offer-info';

interface SliderItemInfoProps {
  banner: BannerModel;
  primaryColor: string;
  secondaryColor: string;
}

const SliderItemInfo: FC<SliderItemInfoProps> = ({
  banner,
  primaryColor,
  secondaryColor,
}) => {
  return banner.bannerableType === 'FILM' ? (
    <SliderFilmInfo
      primaryColor={primaryColor}
      secondaryColor={secondaryColor}
      filmBanner={banner}
    />
  ) : banner.bannerableType === 'OFFER' ? (
    <SliderOfferInfo
      primaryColor={primaryColor}
      secondaryColor={secondaryColor}
      offerBanner={banner}
    />
  ) : banner.bannerableType === 'EXTERNAL_LINK' ? (
    <SliderExternalLinkInfo primaryColor={primaryColor} externalLinkBanner={banner} />
  ) : //WITHOUT_LINK type
  null;
};

export default SliderItemInfo;
